import { useProject } from '../stores/ProjectContext'
import { useI18n } from '../stores/I18nContext'
import './Sidebar.css'

export default function Sidebar() {
  const {
    project,
    selectedFlow,
    selectedCheckpoint,
    setSelectedFlow,
    setSelectedCheckpoint,
    addFlow,
    updateFlow,
    toggleFlowVisibility
  } = useProject()
  const { t } = useI18n()

  const handleAddFlow = () => {
    const colors = ['#E85D04', '#06D6A0', '#118AB2', '#9B5DE5', '#EF476F', '#FFD166']
    const usedColors = project.flows.map(f => f.color)
    const availableColor = colors.find(c => !usedColors.includes(c)) || colors[0]
    const flow = addFlow(t('flow.newFlow'), availableColor)
    setSelectedFlow(flow.id)
  }

  const handleFlowClick = (flowId) => {
    if (selectedFlow === flowId) {
      setSelectedFlow(null)
      setSelectedCheckpoint(null)
    } else {
      setSelectedFlow(flowId)
      setSelectedCheckpoint(null)
    }
  }

  const handleCheckpointClick = (e, flowId, checkpointId) => {
    e.stopPropagation()
    setSelectedFlow(flowId)
    setSelectedCheckpoint(checkpointId)
  }

  // Calculate subtask progress
  const getProgress = (checkpoint) => {
    if (!checkpoint.subtasks || checkpoint.subtasks.length === 0) return null
    const done = checkpoint.subtasks.filter(s => s.done).length
    return { done, total: checkpoint.subtasks.length }
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <span>{t('toolbar.addFlow').replace('Add ', '').replace('Legg til ', '')}</span>
        <button className="sidebar-add-btn" onClick={handleAddFlow} title={t('toolbar.addFlow')}>
          +
        </button>
      </div>

      <div className="sidebar-content">
        {project.flows.length === 0 ? (
          <div className="sidebar-empty">
            <p>{t('empty.noFlows')}</p>
            <button className="btn btn-primary" onClick={handleAddFlow}>
              {t('toolbar.addFlow')}
            </button>
          </div>
        ) : (
          <ul className="flow-list">
            {project.flows.map(flow => {
              const isSelected = selectedFlow === flow.id
              const isHidden = flow.hidden
              const sortedCheckpoints = [...flow.checkpoints].sort((a, b) => a.time - b.time)

              return (
                <li key={flow.id} className={`flow-item ${isSelected ? 'selected' : ''} ${isHidden ? 'hidden-flow' : ''}`}>
                  <div
                    className="flow-header"
                    onClick={() => handleFlowClick(flow.id)}
                  >
                    <button
                      className="visibility-toggle"
                      onClick={(e) => {
                        e.stopPropagation()
                        toggleFlowVisibility(flow.id)
                      }}
                      title={isHidden ? 'Show' : 'Hide'}
                      style={{ color: isHidden ? 'var(--text-muted)' : flow.color }}
                    >
                      {isHidden ? '◯' : '●'}
                    </button>
                    <span
                      className="flow-color"
                      style={{ backgroundColor: flow.color, opacity: isHidden ? 0.3 : 1 }}
                    />
                    <span className="flow-name">{flow.name}</span>
                    <span className="flow-count">{flow.checkpoints.length}</span>
                  </div>

                  {isSelected && sortedCheckpoints.length > 0 && (
                    <ul className="checkpoint-list">
                      {sortedCheckpoints.map(cp => {
                        const progress = getProgress(cp)
                        const isCheckpointSelected = selectedCheckpoint === cp.id

                        return (
                          <li
                            key={cp.id}
                            className={`checkpoint-item ${isCheckpointSelected ? 'selected' : ''}`}
                            onClick={(e) => handleCheckpointClick(e, flow.id, cp.id)}
                          >
                            <span className={`checkpoint-status status-${cp.status}`} />
                            <span className="checkpoint-name">{cp.name}</span>
                            {progress && (
                              <span className="checkpoint-progress">
                                {progress.done}/{progress.total}
                              </span>
                            )}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </li>
              )
            })}
          </ul>
        )}
      </div>

      </aside>
  )
}
